export default "__VITE_ASSET__DCf4Lqgk__"